import de from '../i18n/locales/de/app/script-unit-slugs.json' with { type: 'json' };

/** URL translations are separate from stable lesson IDs and saved practice progress. */
export const SCRIPT_UNIT_ROUTE_LOCALES = { de };
const reverse = Object.fromEntries(Object.entries(SCRIPT_UNIT_ROUTE_LOCALES).map(([ui, slugs]) =>
  [ui, new Map(Object.entries(slugs).map(([key, slug]) => [slug, key]))]));

export function scriptUnitRouteKey(ui, segment) {
  return reverse[ui]?.get(segment)
    || Object.values(reverse).map(slugs => slugs.get(segment)).find(Boolean)
    || segment;
}

export function scriptUnitRouteSegment(ui, key) {
  const id = scriptUnitRouteKey(ui, key);
  return SCRIPT_UNIT_ROUTE_LOCALES[ui]?.[id] || id;
}
